import React from 'react';
import moment from 'moment';
import BaseClass from '@/pages/BaseClass';
import OrderDetail from '@/components/OrderDetail';

import $ from 'jquery';
import {
	Button,
	DatePicker,
	Input,
	Form,
	Select,
	Table,
	Modal,
	Descriptions,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	parseTime,
	formatTime,
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'statusList':{},
			
			'list':[],
			'pageInfo':{
				'current':1,
				'total':0,
				'pageSize':10,
			},
			
			'info':{
			},
			
			'showDialog':false,
		};
	}
	
	componentDidMount()
	{
		document.title = '退款记录 - ' + CommonValue.get('site_name');
		
		this.getList();
		this.getStatusList();
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('refund','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['times'] = [
				moment(filter.time[0]).format('YYYY-MM-DD'),
				moment(filter.time[1]).format('YYYY-MM-DD')
			];
			delete(filter.time);
		}
		return filter;
	}
	getStatusList()
	{
		let url = pcUrl('refund','statusList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'statusList':data,
				});
			});
	}
	showOrder(index)
	{
		let info = this.state.list[index];
		this.setState({
			'showDialog':true,
		},()=>{
			this.orderDetail.init(info['order_id']);
		});
	}
	
	render()
	{
		return (
			<div style={{'padding':'2em'}}>
				<div className="filter">
					{/*
						<div className="float-right">
							<button className="button button-orange" onClick={()=>this.add()}>
								<span className="fa fa-plus-circle"></span>
								&nbsp;
								申请售后
							</button>
						</div>
					*/}
					<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
						<Form.Item name="time">
							<DatePicker.RangePicker />
						</Form.Item>
							<Form.Item name="status">
								<Select allowClear={true} style={{'width':'14em'}} placeholder="选择退款状态">
									{Object.keys(this.state.statusList).map(key=>(
										<Option value={key}>{this.state.statusList[key]}</Option>
									))}
								</Select>
							</Form.Item>
						<Form.Item name="keywords">
							<Input allowClear={true} style={{'width':'14em'}} placeholder="请输入退款或订单编号" />
						</Form.Item>
						<Form.Item name="">
							<button className="button button-green">
								<span className="fa fa-search"></span>
								&nbsp;
								搜索
							</button>
						</Form.Item>
					</Form>
				</div>
				{/*
				<div style={{'margin':'1em 0 1em 0'}}>
					<button className="button button-border" onClick={()=>this.export()}>导出订单</button>
				</div>
				*/}
				<Table
					pagination={{...this.state.pageInfo,'onChange':(page)=>{this.getList(page);}}} dataSource={this.state.list}>
					<Column title="退款编号" dataIndex="refund_sn" width={30*5} ellipsis />
					<Column title="订单编号" dataIndex="order_sn" width={30*5} ellipsis render={(text,row,index)=>(
						<a href="javascript:;" className="text-blue" onClick={()=>this.showOrder(index)}>{row['order_sn']}</a>
						)} />
					<Column title="退款金额" dataIndex="amount" width={30*3} ellipsis render={(text,row,index)=>(
						<>
							{row['amount']}
							{row.status == 20 && row.remark.length>0 && (
							<p style={{'color':'#999'}}>
								({row['remark']})
							</p>
							)}
						</>
					)}/>
				<Column title="退款状态" dataIndex="status" width={30*3} ellipsis render={(text,row,index)=>(
					<span className={{0:'',10:'',20:'text-red'}[row['status']]}>
						{this.state.statusList[row['status']]}
					</span>
					)}/>
					<Column title="申请时间" dataIndex="order_add_time" width={30*4} ellipsis render={(text,row,index)=>parseTime(row['add_time'])}/>
				</Table>
				<Modal
					title="订单信息"
					width={1000}
					visible={this.state.showDialog}
					footer={null}
					onOk={()=>this.submit()}
					onCancel={()=>this.setState({'showDialog':false})}
					>
					<OrderDetail ref={e=>this.orderDetail = e} />
				</Modal>
			</div>
		);
	}
}



